import { useStore } from '@nanostores/react';

import { usePatientPrescriptionsQuery } from '@/entities/rx';
import { PhrTableTab } from '@/features/phr-table';
import { RxPrescriptionsTable } from '@/features/rx-prescriptions-table';
import {
  $patientWorkspaceSearchTarget,
  clearPatientWorkspaceSearchTarget,
} from '@/shared/stores/ui';
import { Separator } from '@/shared/ui/shadcn/separator';

interface PatientMedicationsTabProps {
  userId: string;
}

export function PatientMedicationsTab({ userId }: PatientMedicationsTabProps) {
  const searchTarget = useStore($patientWorkspaceSearchTarget);
  const rxQuery = usePatientPrescriptionsQuery(userId);
  const hasPrescriptions = (rxQuery.data?.prescriptions?.length ?? 0) > 0;
  const openPrescriptionId =
    searchTarget !== null &&
    searchTarget.tabId === 'phr:medications' &&
    searchTarget.resource === 'rx:prescriptions'
      ? searchTarget.resultId
      : undefined;

  return (
    <div className="space-y-6" aria-label="Medications">
      {hasPrescriptions && (
        <>
          <section aria-label="DoseSpot prescriptions">
            <h2 className="text-base font-medium leading-tight tracking-tight">
              Prescribed Through Lotus Health
            </h2>
            <div className="mt-3">
              <RxPrescriptionsTable
                userId={userId}
                openPrescriptionId={openPrescriptionId}
                onConsumeOpenPrescription={clearPatientWorkspaceSearchTarget}
              />
            </div>
          </section>

          <Separator />
        </>
      )}

      <section aria-label="PHR medications">
        <h2 className="text-base font-medium leading-tight tracking-tight">EHR Medications</h2>

        <div className="mt-3">
          <PhrTableTab userId={userId} tableKey="medications" />
        </div>
      </section>
    </div>
  );
}
